import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import { ErrorHandler } from '@playbookux/playbook-web-core';

import {
  Button, ButtonArea, ButtonInverted, Container, Content, Dialog, Header, Input, Row, Text, RadioContainer, Radio,
} from './styles';

const moderatedSettings = {
  zoom_api: {
    label: 'Zoom API',
    value: 'zoom_api',
  },
  custom: {
    label: 'Custom',
    value: 'custom',
  },
};

const ModeratedSettingsModal = (props) => {
  const {
    company, error, loading, onClose, onSubmit, show,
  } = props;
  const { id, callLink, moderatedSettings: settings } = company;

  const inputRef = useRef(null);

  const [value, setValue] = useState();
  const [inputValue, setInputValue] = useState(callLink);
  const [inputError] = useState();

  useEffect(() => {
    if (!show) {
      setValue(null);
      setInputValue('');
    } else {
      setValue(settings === 'custom' ? moderatedSettings.custom.value : moderatedSettings.zoom_api.value);
    }
  }, [show, callLink, settings]);

  useEffect(() => {
    if (value === moderatedSettings.custom.value) {
      inputRef.current.focus();
      setInputValue(callLink);
    }
  }, [value, callLink]);

  return (
    <Container
      active={show}
      onClickOutside={onClose}
      page
    >
      <Dialog>
        <Header as="h1">Moderated Settings</Header>

        <Content>
          <RadioContainer>
            <Radio
              label={moderatedSettings.zoom_api.label}
              name="moderated-settings"
              value={moderatedSettings.zoom_api.value}
              checked={value === moderatedSettings.zoom_api.value}
              onChange={() => setValue(moderatedSettings.zoom_api.value)}
            />
            <Radio
              label={moderatedSettings.custom.label}
              name="moderated-settings"
              value={moderatedSettings.custom.value}
              checked={value === moderatedSettings.custom.value}
              onChange={() => setValue(moderatedSettings.custom.value)}
            />
            <Row>
              <Text as="h3">Call link:</Text>
              <Input
                placeholder={callLink || 'Call link'}
                disabled={value === moderatedSettings.zoom_api.value}
                size="small"
                ref={inputRef}
                value={inputValue}
                onChange={(e) => setInputValue(e.target.value)}
              />
            </Row>
          </RadioContainer>
        </Content>

        {(error) && (
          <ErrorHandler
            error={error}
            defaultMessage="Error updating moderated settings."
          />
        )}

        <ButtonArea>
          <ButtonInverted onClick={onClose}>
            Cancel
          </ButtonInverted>

          <Button
            onClick={() => onSubmit(id, value === 'custom' ? inputValue : null)}
            disabled={loading || inputError || value === 0}
            loading={loading}
          >
            Save
          </Button>
        </ButtonArea>
      </Dialog>
    </Container>
  );
};

ModeratedSettingsModal.propTypes = {
  error: PropTypes.PropTypes.shape({
    message: PropTypes.string,
  }),
  company: PropTypes.shape({
    id: PropTypes.string,
    callLink: PropTypes.string,
    moderatedSettings: PropTypes.string,
  }).isRequired,
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  show: PropTypes.bool,
};

ModeratedSettingsModal.defaultProps = {
  error: null,
  loading: false,
  show: false,
};

export default ModeratedSettingsModal;
